// attendanceThunk.ts
import { createAsyncThunk } from "@reduxjs/toolkit";
import { GeoTrackingDetailsPayload, GeoTrackingDetailsResponse, GeoTrackingPayload, GeoTrackingResponse } from "../../../types/model/geoTrackingTypes";
import { phpClient } from "../../../network";

export const getGeoTrackingList = createAsyncThunk<
  GeoTrackingResponse,
  GeoTrackingPayload,
  { rejectValue: string }
>(
  "attendance/getGeoTrackingList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await phpClient.post<GeoTrackingResponse>({
        url: "/attendance/geotracking_list",
        data: payload,
      });
      return response as GeoTrackingResponse;
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to fetch geo tracking list");
    }
  }
);

export const getGeoTrackingDetails = createAsyncThunk<
  GeoTrackingDetailsResponse,
  GeoTrackingDetailsPayload,
  { rejectValue: string }
>(
  "attendance/getGeoTrackingDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await phpClient.post<GeoTrackingDetailsResponse>({
        url: "/attendance/geotracking_details",
        data: payload,
      });
      return response;
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to fetch tracking details");
    }
  }
);


